import { render, staticRenderFns } from "./SntConfirmDialog.vue?vue&type=template&id=72d2be08&scoped=true&"
import script from "./SntConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./SntConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./SntConfirmDialog.vue?vue&type=style&index=0&id=72d2be08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2be08",
  null
  
)

export default component.exports